// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"3eef1774","101":"e768497e","269":"52d4a66e","357":"7c5874fb","447":"8525b45c","549":"5325c5a5","723":"cdbd057e","730":"38049e04","731":"80d471cf","845":"c1de3ef8"}[chunkId] + ".chunk.js";
};